export class CarrierModel {
  name: string = '';
  carrierId: string = '';
}
